import React, { useState } from "react";
import { sprintTabs } from "../data";
import clsx from "clsx";
import { IPlanningViewsGroup, PlanningViewBy, SprintTabsEnum } from "../types";
import AddButton from "./AddButton";
import RenderTiles from "./RenderTiles";

interface Props {
  groups: IPlanningViewsGroup[];
  viewBy: PlanningViewBy;
  getTileActiveState: (group: IPlanningViewsGroup) => boolean;
  getTileClickHandler: (group: IPlanningViewsGroup) => () => void;
  onAddClick: () => void;
}
const SprintTiles: React.FC<Props> = ({
  groups,
  viewBy,
  getTileActiveState,
  getTileClickHandler,
  onAddClick,
}) => {
  const [activeTab, setActiveTab] = useState(SprintTabsEnum.NEXT_SPRINTS);

  const today = new Date();

  const filteredGroups = groups.filter((group) => {
    if (group.isUnassigned) return false; // handled separately

    if (!group.startDate || !group.endDate) return false;

    const start = new Date(group.startDate);
    const end = new Date(group.endDate);

    if (activeTab === SprintTabsEnum.NEXT_SPRINTS) {
      return start >= today;
    }

    if (activeTab === SprintTabsEnum.PAST_SPRINTS) {
      return end < today;
    }

    return true;
  });
  return (
    <div className="flex flex-col gap-4">
      {groups.map((group) => {
        return (
          group.isUnassigned && (
            <RenderTiles
              key={group.id}
              group={group}
              viewBy={viewBy}
              isActive={getTileActiveState(group)}
              onTileClick={getTileClickHandler(group)}
            />
          )
        );
      })}
      <div className="flex justify-between items-center bg-white shadow-md w-full sticky top-0 z-10">
        {sprintTabs.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={clsx(
                "relative flex flex-row items-center gap-2 px-4 w-full uppercase text-sm font-normal leading-[21px] py-2 hover:bg-gray-400 group border-b-2 ",
                isActive ? "border-primary" : "border-gray-200",
              )}
            >
              <span
                className={clsx(
                  "text-nowrap",
                  isActive ? "font-semibold text-primary" : "text-secondary",
                )}
              >
                {tab.name}
              </span>
            </button>
          );
        })}
      </div>
      {filteredGroups.map((group) => {
        return (
          !group.isUnassigned && (
            <RenderTiles
              key={group.id}
              group={group}
              viewBy={viewBy}
              isActive={getTileActiveState(group)}
              onTileClick={getTileClickHandler(group)}
              shownSprintDetails
            />
          )
        );
      })}
      {activeTab === SprintTabsEnum.NEXT_SPRINTS && (
        <AddButton title={viewBy} onClick={onAddClick} />
      )}
    </div>
  );
};

export default SprintTiles;
